export enum SocialIcon {
  slack = 'slack',
  email = 'email',
  feedbackOrFeatureRequest = 'feedbackOrFeatureRequest',
}

interface SocialIconConfig {
  classes: string;
  href: string;
}

export interface FullSocialIconConfig extends SocialIconConfig {
  name: SocialIcon;
  tooltip: string;
}

export const SOCIAL_ICON_CONFIG: Record<SocialIcon, SocialIconConfig> = {
  slack: {
    classes: 'fab fa-slack',
    href: 'https://cim.slack.com/archives/CER6089EG',
  },
  email: {
    classes: 'fas fa-envelope-open-text',
    href: 'mailto:xPKI_Support@comcast.com',
  },
  feedbackOrFeatureRequest: {
    classes: 'fas fa-comment-alt',
    href: 'https://ccp.sys.comcast.net/secure/CreateIssue!default.jspa',
  },
};

const ICON_CLASS = 'footer__social-icon';

export type SocialIconTooltips = Record<SocialIcon, string>;

export function addIconClass(
  configs: FullSocialIconConfig[],
): FullSocialIconConfig[] {
  return configs.map(config => ({
    ...config,
    classes: `${config.classes}  ${ICON_CLASS}`,
  }));
}

export function socialIconLocalization(
  iconConfigs: Record<SocialIcon, SocialIconConfig>,
): (localization: Record<SocialIcon, string>) => FullSocialIconConfig[] {
  return localization => {
    return Object.values(SocialIcon).map(icon => ({
      ...iconConfigs[icon],
      tooltip: localization[icon],
      name: icon,
    }));
  };
}
